import { MODAL_STATUS } from '../constants';

const defaultState = {
    modalStatus: false,
};

export const languageAndCountry = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case MODAL_STATUS:
            return {
                ...state,
                ...payload,
            };
        default:
            return state;
    }
};
